<template>
    <v-select
        dense
        outlined
        :items="collection ? collection.models : []"
        item-text="region"
        item-value="id"
        :disabled="!loaded"
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'RegionSelect',

    computed: {
        ...mapState('region', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            // here we could filter the models, if needed
            return this.collection ? this.collection.models : [];
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('region', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
